import React from 'react'
import PropTypes from 'prop-types'

const LoadingSpinner = props => {
  const text = props.text ? <p>{props.text}</p> : null
  const classes = `icon icon_spinner10 icon_spin2 spinner LoadingSpinner mb-2 ${props.innerClass}`

  return (
    <div className={props.outerClass}>
      <div style={props.style} className={classes} />
      {text}
    </div>
  )
}

LoadingSpinner.propTypes = {
  style: PropTypes.object,
  text: PropTypes.string,
  outerClass: PropTypes.string,
  innerClass: PropTypes.string,
}

LoadingSpinner.defaultProps = {
  outerClass: '',
  innerClass: '',
  style: {},
}

export default LoadingSpinner
